/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { CountRequestBuilderRequestsMetadata, type CountRequestBuilder } from './count/index.js';
// @ts-ignore
import { type VolumeRequestBuilder, VolumeRequestBuilderRequestsMetadata } from './volume/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /chargepoints/makes
 */
export interface MakesRequestBuilder extends BaseRequestBuilder<MakesRequestBuilder> {
    /**
     * The count property
     */
    get count(): CountRequestBuilder;
    /**
     * The volume property
     */
    get volume(): VolumeRequestBuilder;
}
/**
 * Uri template for the request builder.
 */
export const MakesRequestBuilderUriTemplate = "{+baseurl}/chargepoints/makes";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const MakesRequestBuilderNavigationMetadata: Record<Exclude<keyof MakesRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    count: {
        requestsMetadata: CountRequestBuilderRequestsMetadata,
    },
    volume: {
        requestsMetadata: VolumeRequestBuilderRequestsMetadata,
    },
};
/* tslint:enable */
/* eslint-enable */
